import React from "react";
import './inner-page-content-title-video.styles.css'
import { useHistory } from "react-router-dom";

export default function InnerPageContentTitleVideo() {
    const history = useHistory();

    return (
        <div className="shbg-grey-pallet hundred ui segment stackable grid no-border no-padding no-margin no-radius no-shadow">
            <div className="row no-margin no-padding">
                <div id="demoVideo" className="shbg-pallet black-transparent sixteen wide mobile sixteen wide tablet eight wide computer column no-margin no-padding container-limit background-banner cover background-position-center-bottom">
                    <video src="https://static.cctech.co.in/who-saves-the-day/app-demo-video.mp4" height="100%" width="100%" controls></video>
                </div>
                <div className="sixteen wide mobile sixteen wide tablet eight wide computer column no-margin no-padding">
                    <div className="container-fluid responsive-padding padding-large">
                        <div className="content-block vertical-align-top">
                            <div className="inner-content">
                                <div className="container-limit min-height-136 hide-on-tablet hide-on-mobile"></div>
                                <div className="ui header">
                                    Forge Hackathon 2021 Project
                                </div>
                                <div className="ui huge blue header no-margin">
                                    Who Saves the Day !?
                                </div>
                                <div className="ui small header no-margin">
                                    Autodesk Forge Viewer
                                </div>
                                <div className="ui small header">
                                    This is an application that helps the player regulate the environmental pollution due to the construction of a building. In this game, the player's aim is to reduce the greenhouse emissions of a building by altering various appropriate parameters. This application was made in the Forge Hackathon 2021 event & received First Position.
                                </div>
                                <div className="ui hidden divider"></div>
                                <button className="left-align-text spaced ui right labeled primary icon large button no-radius" onClick={ () => history.push("/home") }>
                                    <i className="right chevron icon"></i>LAUNCH GAME
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}